import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import putReduxGeneralSettings from './actions';
import utils from '../../utils/utils';
import c from '../../temp/config';
import { getCurrentLocale } from '../../utils/func';
import getLayoutResources from '../../services/layoutService';

class FetchGeneralSettingsImpl extends React.Component {
  componentDidMount() {
    this.fetchGeneralSettings();
  }

  fetchGeneralSettings = () => {
    const { generalSettings } = this.props;

    if (generalSettings && generalSettings.isSet) {
      return;
    }

    if (!utils.isDisconnected) {
      getLayoutResources({ sitecoreApiKey: c.sitecoreApiKey, locale: getCurrentLocale() })
        .then((route) => {
          if (route.status === 200 && route.data && route.data.sitecore.context.profileData && route.data.sitecore.context.profileData.app_settings) {
            const { service_apiKey } = route.data.sitecore.context.profileData.app_settings;

            const gs = {
              isSet: true,
              service_apiKey,
            };

            const { putReduxGeneralSettings } = this.props;
            putReduxGeneralSettings(gs);
          }
        });
    }
  };

  render() { return null; }
}

const mapStateToProps = (state) => ({ generalSettings: state.profile.generalSettings });

const mapDispatchToProps = (dispatch) => ({
  putReduxGeneralSettings: (generalSettings) => dispatch(putReduxGeneralSettings(generalSettings)),
});

const FetchGeneralSettings = connect(mapStateToProps, mapDispatchToProps)(FetchGeneralSettingsImpl);

export default FetchGeneralSettings;

FetchGeneralSettingsImpl.propTypes = {
  generalSettings: PropTypes.shape({
    isSet: PropTypes.bool,
    service_apiKey: PropTypes.string,
  }),
  putReduxGeneralSettings: PropTypes.func,
};
